import React from 'react';

const FilterPanel = ({ filters, onFilterChange }) => {
  const segments = [
    'General Hotel',
    'Ski Mountain', 
    'Aquatopia',
    'Camelbeach',
    'Mountain Adventures'
  ];

  const ratings = [1, 2, 3, 4, 5];

  const datePresets = [
    { label: 'All Time', value: 'all' },
    { label: 'Last 30 Days', value: '30days' },
    { label: 'Last 3 Months', value: '3months' },
    { label: 'Last 6 Months', value: '6months' },
    { label: 'Last Year', value: '1year' },
    { label: 'Custom Range', value: 'custom' }
  ];

  const handleFilterChange = (key, value) => {
    onFilterChange({
      ...filters,
      [key]: value
    });
  };

  const handleDatePresetChange = (preset) => {
    const today = new Date();
    let dateFrom = '';
    let dateTo = '';

    switch (preset) {
      case '30days':
        dateFrom = new Date(today.getTime() - (30 * 24 * 60 * 60 * 1000)).toISOString().split('T')[0];
        dateTo = today.toISOString().split('T')[0];
        break;
      case '3months':
        const threeMonthsAgo = new Date(today);
        threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3);
        dateFrom = threeMonthsAgo.toISOString().split('T')[0];
        dateTo = today.toISOString().split('T')[0];
        break;
      case '6months':
        const sixMonthsAgo = new Date(today);
        sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);
        dateFrom = sixMonthsAgo.toISOString().split('T')[0];
        dateTo = today.toISOString().split('T')[0];
        break;
      case '1year':
        const oneYearAgo = new Date(today);
        oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
        dateFrom = oneYearAgo.toISOString().split('T')[0];
        dateTo = today.toISOString().split('T')[0];
        break;
      case 'all':
      default:
        dateFrom = '';
        dateTo = '';
        break;
    }

    onFilterChange({
      ...filters,
      dateFrom,
      dateTo,
      datePreset: preset
    });
  };

  const clearFilters = () => {
    onFilterChange({
      segment: '',
      rating: '',
      dateFrom: '',
      dateTo: '',
      searchText: '',
      datePreset: 'all'
    });
  };

  const hasActiveFilters = Object.values(filters).some(value => value !== '');

  return (
    <div className="filter-panel">
      <div className="filter-header">
        <h3>Filters</h3>
        {hasActiveFilters && (
          <button className="clear-filters" onClick={clearFilters}>
            Clear All
          </button>
        )}
      </div>
      
      <div className="filter-grid">
        <div className="filter-group">
          <label>Business Segment</label>
          <select 
            value={filters.segment}
            onChange={(e) => handleFilterChange('segment', e.target.value)}
          >
            <option value="">All Segments</option>
            {segments.map(segment => (
              <option key={segment} value={segment}>
                {segment}
              </option>
            ))}
          </select>
        </div>

        <div className="filter-group">
          <label>Rating</label>
          <select 
            value={filters.rating}
            onChange={(e) => handleFilterChange('rating', e.target.value)}
          >
            <option value="">All Ratings</option>
            {ratings.map(rating => (
              <option key={rating} value={rating}>
                {rating} Star{rating !== 1 ? 's' : ''}
              </option>
            ))}
          </select>
        </div>

        <div className="filter-group">
          <label>Date Range</label>
          <select 
            value={filters.datePreset || 'all'}
            onChange={(e) => handleDatePresetChange(e.target.value)}
          >
            {datePresets.map(preset => (
              <option key={preset.value} value={preset.value}>
                {preset.label}
              </option>
            ))}
          </select>
        </div>

        {(filters.datePreset === 'custom' || (!filters.datePreset && (filters.dateFrom || filters.dateTo))) && (
          <>
            <div className="filter-group">
              <label>Date From</label>
              <input 
                type="date"
                value={filters.dateFrom}
                onChange={(e) => {
                  handleFilterChange('dateFrom', e.target.value);
                  handleFilterChange('datePreset', 'custom');
                }}
              />
            </div>

            <div className="filter-group">
              <label>Date To</label>
              <input 
                type="date"
                value={filters.dateTo}
                onChange={(e) => {
                  handleFilterChange('dateTo', e.target.value);
                  handleFilterChange('datePreset', 'custom');
                }}
              />
            </div>
          </>
        )}

        <div className="filter-group search-group">
          <label>Search Reviews</label>
          <input 
            type="text"
            placeholder="Search review text..."
            value={filters.searchText}
            onChange={(e) => handleFilterChange('searchText', e.target.value)}
          />
        </div>
      </div>
    </div>
  );
};

export default FilterPanel;